__turbopack_context__.v({
  "footer-buttons": "styles-module-scss-module__tcWwmq__footer-buttons",
  "sparkle": "styles-module-scss-module__tcWwmq__sparkle",
  "sparkle1": "styles-module-scss-module__tcWwmq__sparkle1",
  "sparkle2": "styles-module-scss-module__tcWwmq__sparkle2",
  "sparkle3": "styles-module-scss-module__tcWwmq__sparkle3",
  "sparkle4": "styles-module-scss-module__tcWwmq__sparkle4",
  "sparkle5": "styles-module-scss-module__tcWwmq__sparkle5",
  "sparkle6": "styles-module-scss-module__tcWwmq__sparkle6",
  "subtitle": "styles-module-scss-module__tcWwmq__subtitle",
  "title": "styles-module-scss-module__tcWwmq__title",
  "waypod": "styles-module-scss-module__tcWwmq__waypod",
  "waypod-inner": "styles-module-scss-module__tcWwmq__waypod-inner",
  "waypod-label": "styles-module-scss-module__tcWwmq__waypod-label",
  "waypods-container": "styles-module-scss-module__tcWwmq__waypods-container",
  "waypoint-container": "styles-module-scss-module__tcWwmq__waypoint-container",
});
